import { useNavigate } from 'react-router-dom'

import Button from 'shared/ui/Button_2'

import { ButtonsContainer, Container } from './Styles'

type ToolsProps = {
  openModal?: () => void
  settingsPath: string
  isDisabled?: boolean
}

const Tools: React.FC<ToolsProps> = ({
  openModal,
  isDisabled,
  settingsPath
}) => {
  const navigate = useNavigate()

  return (
    <Container>
      <ButtonsContainer>
        <Button
          onPress={() => navigate(settingsPath)}
          size="sm"
          intent="secondary-base"
          textId={'Tools.settings'}
        />
        <Button
          testID={'ToolsAddButton'}
          onPress={
            !isDisabled && typeof openModal === 'function'
              ? openModal
              : undefined
          }
          size="sm"
          intent="primary-brand-02"
          textId={'Tools.add.page'}
          iconName="plus"
          icon="left"
          isDisabled={isDisabled}
          state={isDisabled ? 'disabled' : 'default'}
        />
      </ButtonsContainer>
    </Container>
  )
}

export default Tools
